<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_faq") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.questionAr')"
            v-model.trim="data.question_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.questionEn')"
            v-model.trim="data.question_en"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.answerAr')"
            v-model.trim="data.answer_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.answerEn')"
            v-model.trim="data.answer_en"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateFaq",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        question_ar: null,
        question_en: null,
        answer_ar: null,
        answer_en: null,
      },
    };
  },

  methods: {
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("question[ar]", this.data.question_ar || "");
      REQUEST_DATA.append("question[en]", this.data.question_en || "");
      REQUEST_DATA.append("answer[ar]", this.data.answer_ar || "");
      REQUEST_DATA.append("answer[en]", this.data.answer_en || "");

      try {
        await this.$axios({
          method: "POST",
          url: "frequentlyAskedQuestions",
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/questions/all" });
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to add FAQ"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },
};
</script>
